/* eslint-disable */
import { Menu, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import DateRangeIcon from '@material-ui/icons/DateRange';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { ORDER_MAX_DAYS_FROM_TODAY } from '../../Constants/Order/Order.constants';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFilters from '../../State/Store/Filters/Selectors/Filters.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Calendar from '../Calendar/Calendar.component';
import I18n from '../I18n/I18n.component';
import './DateNav.component.i18n';
import DateNavPropTypes from './DateNav.component.props';
import dateNavStyles from './DateNav.component.styles';

/**
 * returnNull
 * @returns {null} null
 */
const returnNull = () => null;

/**
 * DateNavComponent
 * @export
 * @class DateNavComponent
 * @extends {React.Component<DateNavComponentComposedProps, DateNavComponentState>}
 */
export class DateNavComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<DateNavComponentProps>}
   * @memberof DateNavComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`DateNav`}
   * @memberof DateNavComponent
   */
  static displayName = `DateNav`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof DateNavComponent
   */
  static propTypes = DateNavPropTypes;

  /**
   * Data specific to the `<DateNavComponent />` instance
   * @type {DateNavComponentState}
   * @memberof DateNavComponent
   */
  state = {
    anchorEl: null,
  };

  /**
   * On handle close
   * @returns {void} void
   * @memberof DateNavComponent
   */
  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  /**
   * Select date range
   * @param {Event} event The `click` event
   * @returns {void} void
   * @memberof DateNavComponent
   */
  onSelectNumberOfDays = (numberOfDays) => {
    const { onDateNav, actions } = this.props;
    this.setState({ rangeOpen: null });
    if (onDateNav) {
      onDateNav(`onSelectNumberOfDays`);
    }
    actions.filtersNumberOfDaysSelected(numberOfDays);
  };

  /**
   * On click today button
   * @returns {void} void
   * @memberof DateNavComponent
   */
  onClickToday = () => {
    const { onDateNav, actions } = this.props;
    if (onDateNav) {
      onDateNav(`onClickToday`);
    }
    actions.filtersTodayDateSelected();
  };

  /**
   * On click prev range
   * @returns {void} void
   * @memberof DateNavComponent
   */
  onClickPrevDateRange = () => {
    const {
      onDateNav,
      actions,
      filters: { startDate, numberOfDays },
    } = this.props;
    if (onDateNav) {
      onDateNav(`onClickPrevDateRange`);
    }
    actions.filtersPrevDateRangeSelected(
      moment(startDate)
        .subtract(numberOfDays, `days`)
        .toISOString(),
    );
  };

  /**
   * On click next range
   * @returns {void} void
   * @memberof DateNavComponent
   */
  onClickNextDateRange = () => {
    const { onDateNav, actions } = this.props;
    if (onDateNav) {
      onDateNav(`onClickNextDateRange`);
    }
    actions.filtersNextDateRangeSelected();
  };

  /**
   * On click calendar date
   * @param {Date} date The `click` event
   * @returns {void} void
   * @memberof DateNavComponent
   */
  onClickStartDate = (date) => {
    this.handleClose();
    const { onDateNav, actions } = this.props;
    if (onDateNav) {
      onDateNav(`onClickStartDate`);
    }
    actions.filtersStartDateSelected(date);
  };

  /**
   * Toggle calendar
   * @param {Event} event The `click` event
   * @returns {void} void
   * @memberof DateNavComponent
   */
  toggleCalendar = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  /**
   * Renders the Today button
   * @returns {React.Component} the component
   * @memberof DateNavComponent
   */
  renderToday() {
    const { classes } = this.props;
    return (
      <Button className={classes.today} id="dateNavTodayButton" onClick={this.onClickToday}>
        <I18n>DateNav.TodayLabel</I18n>
      </Button>
    );
  }

  /**
   * Renders the prev range nav
   * @returns {React.Component} the component
   * @memberof DateNavComponent
   */
  renderPrevRangeNav() {
    const {
      filters: { startDate },
    } = this.props;

    let disabled = false;
    if (
      moment(startDate).format(`DD/MM/YYYY`) ===
      moment()
        .subtract(2, `months`)
        .startOf(`month`)
        .format(`DD/MM/YYYY`)
    ) {
      disabled = true;
    }

    return (
      <IconButton disabled={disabled} id="dateNavRangePrev" onClick={this.onClickPrevDateRange}>
        <ChevronLeft />
      </IconButton>
    );
  }

  /**
   * Renders the range select
   * @returns {React.Component} the component
   * @memberof DateNavComponent
   */
  renderRangeSelect() {
    const { filters } = this.props;
    const { rangeOpen } = this.state;
    const { numberOfDays } = filters;
    return (
      <React.Fragment>
        <Button aria-controls="simple-menu" aria-haspopup="true" onClick={(e) => this.setState({ rangeOpen: e.currentTarget })}>
          {numberOfDays || 3} days / PAGE
        </Button>
        <Menu anchorEl={rangeOpen} autoFocus={false} id="simple-menu" keepMounted onClose={() => this.setState({ rangeOpen: null })} open={Boolean(rangeOpen)}>
          <MenuItem onClick={() => this.onSelectNumberOfDays(3)} selected={numberOfDays === 3}>
            <I18n>DateNav.DateRangeSelectOptions.ThreeDays</I18n>
          </MenuItem>
          <MenuItem onClick={() => this.onSelectNumberOfDays(7)} selected={numberOfDays === 7}>
            <I18n>DateNav.DateRangeSelectOptions.SevenDays</I18n>
          </MenuItem>
          <MenuItem onClick={() => this.onSelectNumberOfDays(30)} selected={numberOfDays === 30}>
            <I18n>DateNav.DateRangeSelectOptions.ThirtyDays</I18n>
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }

  /**
   * Renders the next range nav
   * @returns {React.Component} the component
   * @memberof DateNavComponent
   */
  renderNextRangeNav() {
    const {
      filters: { startDate, numberOfDays },
    } = this.props;
    let disabled = false;
    if (
      moment(startDate)
        .add(numberOfDays, `days`)
        .isAfter(moment().add(ORDER_MAX_DAYS_FROM_TODAY, `days`))
    ) {
      disabled = true;
    }
    return (
      <IconButton disabled={disabled} id="dateNavRangeNext" onClick={this.onClickNextDateRange}>
        <ChevronRight />
      </IconButton>
    );
  }

  /**
   * Renders the calendar button
   * @returns {React.Component} the component
   * @memberof DateNavComponent
   */
  renderCalendarButton() {
    const { classes } = this.props;
    return (
      <IconButton classes={{ root: classes.calendarIcon }} id="dateNavCalendarButton" onClick={this.toggleCalendar}>
        <DateRangeIcon />
      </IconButton>
    );
  }

  /**
   * Renders the calendar
   * @returns {React.Component} the component
   * @memberof DateNavComponent
   */
  renderCalendar() {
    const { filters } = this.props;
    const { startDate, numberOfDays } = filters;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const endDate = moment()
      .add(ORDER_MAX_DAYS_FROM_TODAY, `days`)
      .toDate();
    const minDate = moment()
      .subtract(2, `months`)
      .startOf(`month`)
      .toDate();

    return (
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: `left`,
          vertical: `bottom`,
        }}
        onClose={this.handleClose}
        open={open}
        transformOrigin={{
          horizontal: `left`,
          vertical: `top`,
        }}
        width="auto"
      >
        <Calendar
          maxDate={endDate}
          maxDaysFromMinDate={ORDER_MAX_DAYS_FROM_TODAY}
          minDate={minDate}
          onClickDay={this.onClickStartDate}
          value={[
            moment(startDate).toDate(),
            moment(startDate)
              .add(numberOfDays - 1, `days`)
              .toDate(),
          ]}
        />
      </Popover>
    );
  }

  /**
   * Renders the DateNavComponent
   * @returns {React.Component} the rendered DateNavComponent
   * @memberof DateNavComponent
   */
  render() {
    const { width } = this.props;
    const isSmall = isWidthDown(`sm`, width);
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    return (
      <React.Fragment>
        {!isSmall && this.renderToday()}
        {this.renderCalendarButton()}
        {!isSmall && this.renderPrevRangeNav()}
        {!isSmall && this.renderRangeSelect()}
        {!isSmall && this.renderNextRangeNav()}
        {open && this.renderCalendar()}
      </React.Fragment>
    );
  }
}

/** @type {React.ComponentClass<DateNavComponentProps>} */
const DateNav = compose(
  withWidth(),
  withStyles(themeCreateInjectableStyles(dateNavStyles), { withTheme: true }),
  connect(
    (state) => ({
      filters: getFilters(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...filtersActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(DateNavComponent);

export default DateNav;
